import { render, staticRenderFns } from "./backoffice-configuracao-de-sala.vue?vue&type=template&id=2a5c678c&scoped=true"
import script from "./backoffice-configuracao-de-sala.vue?vue&type=script&lang=ts"
export * from "./backoffice-configuracao-de-sala.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-configuracao-de-sala.vue?vue&type=style&index=0&id=2a5c678c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c678c",
  null
  
)

export default component.exports